import { render, staticRenderFns } from "./SplitIdInfoPanel.vue?vue&type=template&id=84c0f382&scoped=true&"
import script from "./SplitIdInfoPanel.vue?vue&type=script&lang=js&"
export * from "./SplitIdInfoPanel.vue?vue&type=script&lang=js&"
import style0 from "./SplitIdInfoPanel.vue?vue&type=style&index=0&id=84c0f382&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84c0f382",
  null
  
)

export default component.exports